<template>
  <v-container-principal>
    <v-container fluid grid-list-xl>
      <div class="text-h4 mb-6" v-text="'Dados Pessoais'"></div>
      <v-flex xs12>
        <ValidationObserver v-slot="{ invalid }">
          <v-form @submit.prevent="handleOnSubmit" ref="formPersonalData">
            <v-layout row>
              <v-col md="6" sm="12">
                <ValidationProvider
                  name="nome"
                  rules="required"
                  v-slot="{ errors, valid }">
                  <v-text-field
                    v-model="dadosPessoais.username"
                    label="Nome completo"
                    required
                    :error-messages="errors"
                    :success="valid" />
                </ValidationProvider>
              </v-col>
            </v-layout>
            <v-layout row>
              <v-col md="6" sm="12">
                <ValidationProvider
                  name="email"
                  rules="required|email"
                  v-slot="{ errors, valid }">
                  <v-text-field
                    v-model="dadosPessoais.email"
                    label="Email"
                    readonly
                    :error-messages="errors"
                    :success="valid" />
                </ValidationProvider>
              </v-col>
            </v-layout>
            <v-btn type="submit" color="primary" large :disabled="invalid"
              >Atualizar</v-btn
            >
          </v-form>
        </ValidationObserver>

        <ValidationObserver v-slot="{ invalid }">
          <v-form
            @submit.prevent="handleOnChangePassword"
            ref="formPassword"
            lazy-validation>
            <div class="text-h4 mt-md-12 mt-8" v-text="'Alterar senha'"></div>
            <v-layout row>
              <v-col md="6" sm="12">
                <v-text-field
                  v-model="dadosPessoais.currentPassword"
                  label="Senha atual"
                  type="password"></v-text-field>
              </v-col>
            </v-layout>
            <v-layout row>
              <v-col md="6" sm="12">
                <ValidationProvider
                  name="password"
                  vid="confirmation"
                  rules="required|min:6"
                  v-slot="{ errors, valid }">
                  <v-text-field
                    v-model="dadosPessoais.password"
                    label="Nova senha"
                    type="password"
                    required
                    :error-messages="errors"
                    :success="valid"></v-text-field>
                </ValidationProvider>
              </v-col>
            </v-layout>
            <v-layout row>
              <v-col md="6" sm="12">
                <ValidationProvider
                  name="confirmPassword"
                  rules="required|min:6|confSenha:confirmation"
                  v-slot="{ errors, valid }">
                  <v-text-field
                    v-model="dadosPessoais.passwordConfirmation"
                    label="Confirmação de senha"
                    type="password"
                    required
                    :error-messages="errors"
                    :success="valid"></v-text-field>
                </ValidationProvider>
              </v-col>
            </v-layout>
            <v-btn
              type="submit"
              color="primary"
              large
              :disabled="invalid"
              :loading="changePasswordBtnLoading">
              Alterar Senha
            </v-btn>
          </v-form>
        </ValidationObserver>
      </v-flex>
    </v-container>
  </v-container-principal>
</template>
<script>
import { mapActions, mapGetters } from "vuex"
import { ValidationObserver, ValidationProvider } from "vee-validate"
import VContainerPrincipal from "../components/VContainerPrincipal"
import { RepositoryFactory } from "../repositories/repositoryFactory"

const usuarioRepository = RepositoryFactory.get("usuario")

const DADOS_ALTERADOS = "Dados alterados com sucesso!"
const DADOS_ALTERADOS_ERRO = "Erro ao alterar dados pessoais!"
const SENHA_ALTERADA = "Senha alterada com sucesso!"

export default {
  components: { VContainerPrincipal, ValidationObserver, ValidationProvider },

  data() {
    return {
      dadosPessoais: {
        username: null,
        email: null,
        currentPassword: "",
        password: "",
        passwordConfirmation: "",
      },

      changePasswordBtnLoading: false,
    }
  },

  created() {
    this.loadUser(this.userId)
  },

  methods: {
    loadUser(id) {
      usuarioRepository.getOne(id).then((response) => {
        this.dadosPessoais.username = response.data.username
        this.dadosPessoais.email = response.data.email
      })
    },

    handleOnSubmit() {
      const payload = {
        username: this.dadosPessoais.username,
        email: this.dadosPessoais.email,
      }

      if (this.$refs.formPersonalData.validate()) {
        usuarioRepository
          .update(payload)
          .then((response) => {
            if (response.status === 200) {
              this.showSucesso(DADOS_ALTERADOS)
              this.$store.dispatch("auth/updateUsername", {
                username: payload.username,
              })
            }
          })
          .catch(() => {
            this.showErro(DADOS_ALTERADOS_ERRO)
          })
      }
    },

    handleOnChangePassword() {
      const payload = {
        currentPassword: this.dadosPessoais.currentPassword,
        password: this.dadosPessoais.password,
        passwordConfirmation: this.dadosPessoais.passwordConfirmation,
      }

      if (this.$refs.formPassword.validate()) {
        this.changePasswordBtnLoading = true
        usuarioRepository
          .changePassword(payload)
          .then((response) => {
            if (response.status === 200) {
              this.showSucesso(SENHA_ALTERADA)

              this.dadosPessoais.currentPassword =
                this.dadosPessoais.password =
                this.dadosPessoais.passwordConfirmation =
                  null
            } else {
              this.showErro(response.data.error.message)
            }
          })
          .catch(({ response }) => {
            this.showErro(response.data.error.message)
          })
          .finally(() => {
            this.changePasswordBtnLoading = false
          })
      }
    },

    ...mapActions("message", ["showSucesso", "showErro"]),
  },

  computed: {
    ...mapGetters({
      userId: ["auth/userId"],
    }),
  },
}
</script>
